import {
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogBackdrop,
} from '@headlessui/react'
import { ReactNode } from 'react'
import { cn } from '../utilities.ts'
import { CloseIcon } from '../icons/general.tsx'

export type DrawerProps = {
  open: boolean
  setOpen: (open: boolean) => void
  children: ReactNode
  title?: string
  cssClass?: string
}

export default function Drawer({
  open,
  setOpen,
  children,
  title,
  cssClass = 'z-20',
}: DrawerProps) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      className={cn('relative', cssClass, open ? 'block' : 'hidden')}
    >
      <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-25 transition-opacity" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel
              transition
              className="pointer-events-auto w-screen max-w-md transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
            >
              <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-start justify-between">
                    <DialogTitle
                      className={cn(
                        'text-base font-semibold leading-6 text-gray-900'
                      )}
                    >
                      {title === undefined ? ' ' : title}
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <button
                        type="button"
                        onClick={() => setOpen(false)}
                        className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      >
                        <span className="sr-only">Close panel</span>
                        <CloseIcon />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">
                  {children}
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  )
}
